import { render, staticRenderFns } from "./OsListMovimentacao.vue?vue&type=template&id=22228835&"
import script from "./OsListMovimentacao.vue?vue&type=script&lang=js&"
export * from "./OsListMovimentacao.vue?vue&type=script&lang=js&"
import style0 from "./OsListMovimentacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports